export const ROUTE = {
    BASE_URL: "/",
    ABOUT_US: "/about-us",
    PRODUCTS: {
        BASE_URL: "/products/simulator",
        DETAIL: "/products/:id",
    },
    INDUSTRY: "/industries",
    PARTNER_AND_CLIENT: "/partner-and-client",
    NEWS_ARTICLES: "/news-and-articles",
    NEWS: {
        BASE_URL: "/news",
        DETAIL: "/news/:slug"
    },
    ARTICLES: {
        BASE_URL: "/articles",
        DETAIL: "/articles/:slug"
    },
    CONTACT_US: "/contact-us",
    VCARD: "/vcard/:slug",
}

export const FEATURE_ID = {
    HOME: "home",
    ABOUT: "about",
    PRODUCT: "product",
    SERVICE: "service",
    INDUSTRY: "industry",
    PARTNER_CLIENT: "partner_client",
    NEWS_ARTICLE: "news_article",
    NEWS: "news",
    ARTICLE: "article",
    CONTACT: "contact",
    VCARD: "vcard",
}

export const KEY = Object.freeze({
    RECAPTCHA_SITE: "6LfrTw0qAAAAAJG-dTp6YX_60JUNR9yoJkxW4ggG",
    QUERY: {
        ALL_NEWS: "all-news",
        ALL_ARTICLES: "all-articles",
        LATEST_NEWS: "latest-news",
        LATEST_ARTICLES: "latest-articles",
    }
})

export const API = Object.freeze({
    BASE_URL: "https://cms.k-egp.com/api",
    CONTACT: "/contacts",
    NEWS: "/newss",
    ARTICLES: "/articles",
})

export const GENERAL = Object.freeze({
    BASE_URL: "https://cms.k-egp.com",
    LINKEDIN_URL: "https://www.linkedin.com/company/enterprise-global-projects-corporation/",
    INSTAGRAM_URL: "https://www.instagram.com/official.egp/",
    WEBSITE: "https://k-egp.com/",
})